import { render, staticRenderFns } from "./PepperTopic.vue?vue&type=template&id=7af48f1c&"
import script from "./PepperTopic.vue?vue&type=script&lang=js&"
export * from "./PepperTopic.vue?vue&type=script&lang=js&"
import style0 from "./PepperTopic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports